<template>
  <div class="content">
    <el-row type="flex">
      <el-col :span="12">
        <el-form
          label-position="top"
          :rules="rules"
          ref="form"
          label-width="80px"
          :model="form"
        >
          <el-form-item label="中文折扣码标题" prop="lang_list[1].title">
            <el-input
              v-model="form.lang_list[1].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文折扣码标题" prop="lang_list[0].title">
            <el-input
              v-model="form.lang_list[0].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="繁体折扣码标题" prop="lang_list[2].title">
            <el-input
              v-model="form.lang_list[2].title"
              placeholder="请输入折扣码标题"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="兑换所需积分" prop="exchange_value">
            <el-input-number
              :controls="false"
              min="0"
              :precision="0"
              :step="1"
              v-model="form.exchange_value"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="使用时间" prop="date">
            <el-row type="flex">
              <el-date-picker
                v-model="form.date"
                @change="changedata"
                format="yyyy 年 MM 月 dd 日 hh:mm:ss"
                value-format="yyyy-MM-dd hh:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <!-- <div class="m-l-10">
                <el-checkbox v-model="form.checked">不限结束时间</el-checkbox>
              </div> -->
            </el-row>
          </el-form-item>
          <el-form-item label="折扣" prop="value">
            <el-input-number
              placeholder="请输入"
              max="100"
              min="0"
              :controls="false"
              type="number"
              v-model="form.value"
            >
            </el-input-number>
            %
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回 </el-button>
              <el-button type="primary" @click="store" :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form></el-col
      >
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '非会员',
        },
        {
          value: '选项2',
          label: '网红',
        },
        {
          value: '选项3',
          label: '套餐A',
        },
        {
          value: '选项4',
          label: '套餐B',
        },
      ],

      btnLoading: false,
      rules: {
        'lang_list[0].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[1].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[2].title': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        value: [
          {
            required: true,
            message: '请输入折扣',
            trigger: 'change',
          },
        ],
        date: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        exchange_value: [
          {
            required: true,
            message: '请输入兑换所需积分',
            trigger: 'change',
          },
        ],
      },
      form: {
        id: '',
        date: '',
        lang_list: [
          {
            lang: 'en_US',
            title: '',
          },
          {
            lang: 'zh-CN',
            title: '',
          },
          // {
          //   lang: 'zh-TW',
          //   title: '',
          // },
        ],
        start_at: '',
        end_at: '',
        value: '',
        exchange_value: '',
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    detail() {
      request({
        url: '/api/backend/coupon/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
          this.form.date = [res.data.start_at, res.data.end_at]
        }
      })
    },
    store() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/coupon/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/operation/RPlist',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    changedata(val) {
      console.log(val)
      this.form.start_at = val[0]
      this.form.end_at = val[1]
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
